import { createSelector } from 'reselect';
import { RootState } from 'src/store/storeManager';

const getScenePreviews = (state: RootState) => state.sceneConfiguration.previews;

const getPreviewScenes = createSelector([getScenePreviews], (previews) => previews);

export default getPreviewScenes;
